<template>
  <Modal
    class="modal-verify-password"
    size="md"
    :is-open="props.isOpen"
    @close="$emit('close')"
  >
    <div class="modal-verify-password__content">
      <Heading :level="3">Digite sua senha para continuar</Heading>
      <SingleInput
        v-model="inputPassword"
        type="password"
        :status="computedPasswordStatus"
        :helper-text="props.isPasswordInvalid ? 'Senha inválida' : ''"
      />
    </div>
    <template #buttonContainer>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary
            label="Confirmar"
            :loading="props.isLoading"
            @click="$emit('confirm', inputPassword)"
          />
        </template>
        <template #button-secondary>
          <ButtonSecondary label="Cancelar" @click="$emit('close')" />
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import {
  Modal,
  Heading,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  SingleInput
} from '@warrenbrasil/nebraska-web';
import { ref, computed } from 'vue';

interface Props {
  isOpen: boolean;
  isPasswordInvalid: boolean;
  isLoading: boolean;
}

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm', inputPassword: string): void;
}

const props = defineProps<Props>();

defineEmits<EmitEvents>();

const inputPassword = ref('');

const computedPasswordStatus = computed(() => {
  return props.isPasswordInvalid ? 'error' : '';
});
</script>

<style lang="less" scoped>
:deep(.base-modal--header) {
  display: none;
}
.modal-verify-password {
  &__content {
    text-align: left;
    margin: @size-spacing-x1000 0;
  }
}
</style>
